import React, { useCallback, useState, useEffect } from 'react'
import { useModal } from 'react-modal-hook'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import AccountDisplay from '../../components/account-display/account-display'
import BeneficiaryDisplay from '../../components/beneficiary-display/beneficiary-display'
import Modal from '../../components/Modal/Modal'
import NeoButton from '../../components/NeoButton/NeoButton'
import { Formik, Form, Field } from 'formik'
import NeoInput from '../../components/NeoInput/NeoInput'
import InputError from '../../components/InputError/InputError'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import NeoOTP from '../../components/FormComponents/NeoOTP'
import Loading from 'custom/assets/loaders/Loading'
import TermsAndCondition from '../../components/TermsAndConditions/TermsAndCondition'
import { getCurrentAccDetailsSelector, getRoleAccessKeySelector } from '../../store/selectors/app.selector'
import { OwnTransferSchema } from '../../schemas/transfers'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import TransferService from '../../services/transfer.service'
import { setIsAcctRefresh } from '../../store/actions/app.actions'
import {
  BUTTON_KEYS,
  BENEFICIARY_TRANSFER_KEYS,
  VALIDATION_KEYS,
} from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
import NumberFormat from 'react-number-format'
import QuickLinkService from '../../services/quick-link.service'
const ownTransferConfig = validationConfig['transfers']['own']

const smsAlertList = [
  { label: 'All', value: 'A' },
  { label: 'None', value: 'N' },
  { label: 'SMS Alert', value: 'S' },
  { label: 'Email Alert', value: 'E' },
]
export default function OwnAccountTransfer() {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(1)
  const [otp, setOtp] = useState('')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [beneDetails, setBeneDetails] = useState({})
  const [formValues, setFormValues] = useState({})
  const [verifyDetails, setVerifyDetails] = useState({})
  const [transferType, setTransferType] = useState({})
  const [currencyList, setCurrencyList] = useState([])
  const [remarksList, setRemarksList] = useState([])
  const currentAccountDetail = useSelector(getCurrentAccDetailsSelector)
  const [selectedModeOfTransfer, setSelectedModeOfTransfer] = useState('Y')
  const [requestDetails, setRequestDetails] = useState({})
  const accessKey = useSelector(getRoleAccessKeySelector)
  const [successResponse, setSuccessResponse] = useState({})

  const { t } = useTranslation()

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{message?.code}</b> : {message?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  useEffect(() => {
    if (location.state === undefined) {
      history.push('/transfers')
      return
    }
    console.log(location?.state)
    setBeneDetails(location?.state?.beneDetails)
    setTransferType(location?.state?.transferType)
    if (location?.state?.beneDetails?.currency === currentAccountDetail?.currency) {
      setCurrencyList([location?.state?.beneDetails?.currency])
    } else {
      setCurrencyList([location?.state?.beneDetails?.currency, currentAccountDetail?.currency])
    }
    // fetchCurrencyList()
    // fetchInternalCurrencyList()
  }, [currentAccountDetail])

  const onVerify = useCallback(
    async (values) => {
      try {
        setLoading(true)
        setFormValues(values)
        if (values.transferAmount === '0.00' || values.transferAmount === '.00') {
          return
        }
        // const bankAlertType = smsAlertList.filter((ele) => ele.label === values.beneAlert)[0]

        const reqParams = {
          transferReq: {
            fin: {
              srcAccount: currentAccountDetail.accountNo,
              srcAccBranch: currentAccountDetail.brnCode,
              srcAccCcy: currentAccountDetail.currency,
              destAccount: beneDetails.accountNo,
              destAccBranch: beneDetails.brnCode,
              destAccCcy: beneDetails.currency,
              destBankName: '',
              destBankCountry: '',
              destBankAddress: '',
              beneAddress: '',
              modeOfTransfer: '',
              amount: values.transferAmount,
              txnCurrency: values.txnCurrency,
              bicCode: '',
              sortCode: '',
              remarks: values.remarks,
              chargesBorneBy: '',
              txnDate: '',
            },
            nfin: {
              transferType: 'OAT',
              beneId: 0,
              scheduled: values.isScheduled === 'Yes' ? true : false,
              scheduledDate: values.scheduledDate || '',
              beneficiaryName: beneDetails.customerName,
              beneficiaryMail: '',
              beneficiaryMobile: '',
              addBeneficiary: false,
              bulkTransfer: false,
            },
            cdf: {},
          },
        }
        const response = await TransferService.verifyOwnAccTransfer(reqParams)
        if (response.status === 200) {
          setOtpEnabled(response.data['otpEnable'])
          setVerifyDetails(response.data)
          setRequestDetails(reqParams)
          setStage(2)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
        setMessage(err?.data)
        //showModal()
      }
    },
    [beneDetails, transferType, currentAccountDetail],
  )

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const reqParams = {
        ...requestDetails,
        otp: otp || '0000',
        randomKey: verifyDetails.randomKey,
      }

      const response = await TransferService.confirmOwnAccTransfer(reqParams)
      if (response.status === 200) {
        setSuccessResponse(response.data)
        setMessage(response.data['message'])
        dispatch(setIsAcctRefresh(true))
        setStage(4)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      setMessage(err?.data)
      setOtp('')
      //showModal()
    }
  }, [otp, verifyDetails, requestDetails])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirm()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
      case 4:
        return <NeoSuccess
          onClick1={async () =>
            await QuickLinkService.pdfReceipt({
              transRefNum: successResponse.referenceNo,
              refId: '',
              module: 'FUNDTRANSFER',
            })}
          module='DOWNLOAD_RECEIPT'
          roleKey={accessKey}
          message={message}
          linkPath='/transfers' />
      default:
        return renderForm()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    return (
      <>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <p style={{ fontSize: 10, fontWeight: 600, paddingLeft: 30 }}>To</p>
        <BeneficiaryDisplay
          beneDetails={{
            image: null,
            beneName: beneDetails?.customerName,
            beneAccNo: beneDetails?.accountNo,
          }}
        />
        <Formik
          initialValues={{
            transferAmount: '',
            remarks: '',
            // hasFxRefNo: 'Y',
            // fxRefNo: '',
            txnCurrency: beneDetails?.currency,
            // customRemarks: '',
            // beneAlert: 'All',
          }}
          enableReinitialize
          validationSchema={OwnTransferSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, setFieldValue, handleChange, values }) => (
            <Form>
              <div className='form-group'>
                <NeoInput
                  tabIndex={'1'}
                  showAsterisk={ownTransferConfig['isAmountRequired']}
                  text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_AMOUNT)}
                  name='amount'
                  onChange={(values) => {
                    setFieldValue('transferAmount', values.value)
                  }}
                  mode='amount'
                />
                <InputError text={errors.transferAmount} touched={touched.transferAmount} />

                <InputError
                  text={t(VALIDATION_KEYS.TRANSFER_AMOUNT_VALIDATION)}
                  touched={values.transferAmount === '0.00' || values.transferAmount === '.00'}
                />
              </div>

              <div className='mt-3 form-group'>
                <NeoInput
                  tabIndex={'2'}
                  showAsterisk={ownTransferConfig['isCurrencyRequired']}
                  text={t(BENEFICIARY_TRANSFER_KEYS.CURRENCY)}
                  mode='select'
                  name='txnCurrency'
                  onChange={(e) => {
                    handleChange(e)
                  }}
                  list={currencyList}
                  keyValue={null}
                />
                <InputError text={errors.txnCurrency} touched={touched.txnCurrency} />
              </div>

              {/* <div style={{ marginTop: 20 }}>
                <div className='custom-control custom-radio custom-control-inline pt-20'>
                  <h5>{t(BENEFICIARY_TRANSFER_KEYS.HAS_FX_DEAL)} ?</h5>
                </div>

                <div className='custom-control custom-radio custom-control-inline pt-20'>
                  <Field
                    as='input'
                    type='radio'
                    id='transferTypeSelect3'
                    name='hasFxRefNo'
                    value='Y'
                    onChange={(text) => {
                      handleChange(text)
                      setSelectedModeOfTransfer(text.target.value)
                    }}
                    className='custom-control-input'
                  />
                  <label className='custom-control-label' htmlFor='transferTypeSelect3'>
                  {t(BENEFICIARY_TRANSFER_KEYS.YES)}
                  </label>
                </div>

                <div className='custom-control custom-radio custom-control-inline'>
                  <Field
                    as='input'
                    type='radio'
                    id='transferTypeSelect2'
                    name='hasFxRefNo'
                    value='N'
                    onChange={(text) => {
                      handleChange(text)
                      setSelectedModeOfTransfer(text.target.value)
                    }}
                    className='custom-control-input'
                  />
                  <label className='custom-control-label' htmlFor='transferTypeSelect2'>
                  {t(BENEFICIARY_TRANSFER_KEYS.NO)}
                  </label>
                </div>

                {selectedModeOfTransfer === 'Y' && (
                  <>
                    <NeoInput text={t(BENEFICIARY_TRANSFER_KEYS.FX_REF_NO)} showAsterisk={ownTransferConfig['isFxRefNoRequired']} name='fxRefNo' onChange={handleChange} />
                    <InputError text={errors.fxRefNo} touched={touched.fxRefNo} />
                  </>
                )}
              </div> */}

              {/* <div className='mt-3 form-group'>
                <NeoInput
                  showAsterisk={ownTransferConfig['isBeneAlertRequired']}
                  text={t(BENEFICIARY_TRANSFER_KEYS.BANK_ALERT)}
                  mode='select'
                  name='beneAlert'
                  onChange={(e) => {
                    handleChange(e)
                  }}
                  list={smsAlertList}
                  keyValue={'label'}
                />
                <InputError text={errors.beneAlert} touched={touched.beneAlert} />
              </div> */}

              <div className='mt-3 form-group'>
                <NeoInput
                  tabIndex={'3'}
                  text={t(BENEFICIARY_TRANSFER_KEYS.REMARKS)}
                  showAsterisk={ownTransferConfig['isRemarksRequired']}
                  onChange={handleChange}
                  name='remarks'
                />
                <InputError text={errors.remarks} touched={touched.remarks} />
              </div>

              <div className='mt-3'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex={'4'}
                    type='submit'
                    mode={'newDesign'}
                    disabled={isSubmitting}
                    text={t(BUTTON_KEYS.SUBMIT)}
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
              <button tabIndex={'5'} className='back-cancel-btn btn btn-sm new-design-warning-text-color' onClick={() => history.goBack()}>
                {t(BUTTON_KEYS.CANCEL)}
              </button>
              </div>
            </Form>
          )}
        </Formik>
      </>
    )
  }

  function renderConfirm() {
    return (
      <>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <p style={{ fontSize: 10, fontWeight: 600, paddingLeft: 30 }}>To</p>
        <BeneficiaryDisplay
          beneDetails={{
            image: null,
            beneName: beneDetails?.customerName,
            beneAccNo: beneDetails?.accountNo,
          }}
        />
        <div className='d-flex flex-column confirmation'>
          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_AMOUNT)}</h6>
            <h6 className='value'>{formValues?.transferAmount}</h6>
          </div>

          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.CHARGES)}</h6>
            <h6 className='value'>
              <NumberFormat
                value={verifyDetails?.charges || 0}
                displayType={'text'}
                thousandSeparator={true}
                prefix={''}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
              />
            </h6>
          </div>
          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.CURRENCY)}</h6>
            <h6 className='value'>{formValues.txnCurrency}</h6>
          </div>

          {/* <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.HAS_FX_DEAL)}</h6>
            <h6 className='value'>{formValues.hasFxRefNo === 'N' ? 'No' : 'Yes'}</h6>
          </div>

          {formValues.hasFxRefNo === 'Y' && (
            <div>
              <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.FX_REF_NO)}</h6>
              <h6 className='value'>{formValues.fxRefNo}</h6>
            </div>
          )} */}

          {/* <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.BANK_ALERT)}</h6>
            <h6 className='value'>{formValues?.beneAlert}</h6>
          </div> */}
          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.REMARKS)}</h6>
            <h6 className='value'>
              {formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks}
            </h6>
          </div>

          <div>
            <TermsAndCondition module="BENEFICIARYTRANSFER" />
          </div>

          <div className='mt-3'>
            {loading ? (
              renderLoading()
            ) : (
              <NeoButton
                mode='newDesign'
                type='button'
                className='btn btn-neo'
                onClick={() => (otpEnabled ? setStage(3) : onConfirm())}
                text={t(BUTTON_KEYS.CONFIRM)}
              />
            )}
          </div>
          <div className='back-cancel-style' onClick={() => setStage(1)}>
            {t(BUTTON_KEYS.BACK)}
          </div>
        </div>
      </>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='TRANSFER_OWN'>
      <div className='new-design-form-style'>
        <div className='heading-style'>{t(BENEFICIARY_TRANSFER_KEYS.TITLE_OWN)}</div>

        <div>{renderSwitch()}</div>
      </div>
    </LayoutWithAccountCard>
  )
}
